import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import dayjs from "dayjs"
import http from "@services/httpService"

class PhaseCodeService {
  public async createOrUpdate(body: any) {
    if (body.birthDate) {
      body.birthDate = dayjs(body.birthDate).toISOString()
    }
    const res = await http.post(
      "api/services/app/PhaseCode/CreateOrUpdate",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )

    return res.data.result
  }

  public async activateOrDeactivate(id: number, isActive) {
    const res = await http.post(
      "api/services/app/PhaseCode/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }

    const res = await http.get("api/services/app/PhaseCode/Get", {
      params: { id },
    })

    return res.data.result
  }

  public async getAll(params: any): Promise<any> {
    const res = await http.get("api/services/app/PhaseCode/GetAll", { params })
    const result = res.data.result

    return result
  }

  public async getAllChild(params: any): Promise<any[]> {
    const res = await http.get("api/services/app/PhaseCode/GetAllChild", {
      params,
    })
    const result = res.data.result

    return result
  }

  public async getListChild(params: any): Promise<any[]> {
    const res = await http.get("api/services/app/PhaseCode/GetListChild", {
      params,
    })
    const result = res.data.result

    return result
  }
}

export default new PhaseCodeService()
